export default __webpack_public_path__ + "static/media/loanpal_pro_app_store@2x.33216250.png";